import EncoderAPI from "@/src/api/EncoderAPI";
import StatsAPI from "@/src/api/StatsAPI";

import type { Query } from "@/src/api/BaseAPI";
import type { GetLiveStatsResponse } from "@/src/api/EncoderAPI.types";
import type {
  GetContentCountriesResponse,
  GetContentViewsGraphResponse,
  GetDevicesUsedByContentResponse,
  GetLiveViewersResponse,
  GetMediaKpiResponse,
} from "@/src/api/StatsAPI.types";
import type { AnalyticsPeriod } from "@/src/hooks/usePeriodFilter";

const LIVE_VIEWERS_REFETCH_MS = 5000;

export function getLiveViewersRefetchInterval(
  isOnAir: boolean,
): number | false {
  return isOnAir ? LIVE_VIEWERS_REFETCH_MS : false;
}

export function mediaKpiQuery(
  projectSlug: string,
  mediaUuid: string,
): Query<GetMediaKpiResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getMediaKpi,
    params: [{ mediaUuid, projectSlug }],
  });
}

export function contentViewsGraphQuery(
  projectSlug: string,
  contentId: string,
  { startDate, endDate }: AnalyticsPeriod,
): Query<GetContentViewsGraphResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getContentViewsGraph,
    params: [{ contentId, projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function contentDevicesQuery(
  projectSlug: string,
  contentId: string,
  { startDate, endDate }: AnalyticsPeriod,
): Query<GetDevicesUsedByContentResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getDevicesUsedByContent,
    params: [{ contentId, projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function contentCountriesQuery(
  projectSlug: string,
  contentId: string,
  { startDate, endDate }: AnalyticsPeriod,
): Query<GetContentCountriesResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getContentCountries,
    params: [{ contentId, projectSlug, startDate, endDate }],
    options: { keepPreviousData: true },
  });
}

export function liveViewersQuery(
  projectSlug: string,
  liveUuid: string,
): Query<GetLiveViewersResponse> {
  return StatsAPI.generateQuery({
    fn: StatsAPI.getLiveViewers,
    params: [{ liveUuid, projectSlug }],
  });
}

export function liveStatsQuery(liveUuid: string): Query<GetLiveStatsResponse> {
  return EncoderAPI.generateQuery({
    fn: EncoderAPI.getLiveStats,
    params: [liveUuid],
  });
}
